<script>
export default {
  name: 'ConfirmOperator',

  props: {
    pure: Boolean,
    config: Object,
  },

  computed: {
    confirmConfig() {
      const config = {}
      if (!this.pure) {
        Object.assign(config, this.config, this.$parent.$attrs['confirm-config'])
      } else {
        return this.config
      }
      return config
    },
  },

  render(h) {
    return h('span', {
      on: {
        click: (e) => {
          e.stopPropagation()
          this.open()
        },
      },
    }, [
      this.createButton(h),
    ])
  },

  inject: {
    $Container: {
      from: '$Container',
      default: undefined,
    },
  },

  methods: {
    createButton(h) {
      const buttonProps = {
        size: 'small',
        disabled: this.disabled,
      }
      const button = this.$parent.$slots.default || this.$slots.button
      if (Array.isArray(button)) {
        return button[0]
      }
      return h('Button', { props: buttonProps }, this.buttonConfig.text)
    },
    open() {
      const config = {
        loading: true,
        onOk: this.ok.bind(this),
      }
      this.$Modal.confirm(Object.assign(config, this.confirmConfig))
    },
    async ok() {
      try {
        const result = await this.run('submit')
        this.$parent.$emit('success', result)
        this.close()
      } catch (e) {
        this.$Message.error({
          content: e.message,
        })
      }
    },
    close() {
      this.$Modal.remove()
    },
    run(name, ...args) {
      const vm = this.$Container ? this.$Container.$refs.Content : this.$parent
      if (!vm || !name) return
      if (vm[name] instanceof Function) {
        return vm[name](...args)
      }
    },
  },
}
</script>

<style scoped>

</style>
